module.exports = __webpack_public_path__ + "static/media/login-icon.8b40210d.svg";